import { render, staticRenderFns } from "./RealnameDialog.vue?vue&type=template&id=98c5e75a"
import script from "./RealnameDialog.vue?vue&type=script&lang=js"
export * from "./RealnameDialog.vue?vue&type=script&lang=js"
import style0 from "./RealnameDialog.vue?vue&type=style&index=0&id=98c5e75a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports